import BlogFortyOneContainer from "./container/BlogFortyOneContainer";
export default BlogFortyOneContainer;
